module.exports = __webpack_public_path__ + "img/status-promotion.39feca67.png";